// Random celebration phrases for use-task-celebration.js — no key-lookup, direct locale import.
export const nl = {
  taskCompletedPhrases: [
    'Lekker bezig!',
    'Goed gedaan!',
    'Klasse!',
    'Topper!',
    'Heerlijk!',
    'Mooi werk!',
    'Bam!',
    'Fantastisch!',
    'Geweldig!',
    'Weer eentje afgevinkt!',
    'Netjes!',
    'Zo doen we dat!',
    'Onstuitbaar!',
    'Lekker gewerkt!',
    'Uitstekend!',
    'Boom!',
    'Chapeau!',
    'Trots op je!',
  ],
  allDonePhrases: [
    'Bam! Alles voor vandaag is af! 🏖️',
    'Lekker bezig! Je bent helemaal bij voor vandaag. 🚀',
    'Boom! Vandaag is helemaal leeggespeeld. 🎮',
    'Fantastisch! Tijd voor ontspanning, alles is af. ☕',
    'Missie volbracht! Je hebt de dag overwonnen. 🏆',
    'Geweldig! Geen actieve taken meer voor vandaag. 🌟',
    'Netjes! Je hebt je hele lijst voor vandaag afgewerkt. 👏',
  ],
};

export const en = {
  taskCompletedPhrases: [
    'Nice work!',
    'Well done!',
    'Class act!',
    'Champion!',
    'Lovely!',
    'Great job!',
    'Boom!',
    'Fantastic!',
    'Awesome!',
    'Another one ticked off!',
    'Nicely done!',
    "That's how it's done!",
    'Unstoppable!',
    'Great effort!',
    'Excellent!',
    'Boom!',
    'Chapeau!',
    'Proud of you!',
  ],
  allDonePhrases: [
    'Boom! Everything for today is done! 🏖️',
    "Nice work! You're fully caught up for today. 🚀",
    'Boom! Today is completely cleared out. 🎮',
    'Fantastic! Time to relax, everything is done. ☕',
    "Mission accomplished! You've conquered the day. 🏆",
    'Awesome! No active tasks left for today. 🌟',
    "Nicely done! You've cleared your whole list for today. 👏",
  ],
};
